import { UnoStoreHooks } from "@simulanisindia/ui";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const { useUnoSelector } = UnoStoreHooks;


const PhoneNumberInput = ({ value, onChange, isEditing = false }) => {
  
  const configData = useUnoSelector((state) => state.config);

  const validate = (val, countryData) => {
    if (!val || countryData.dialCode.length >= val.length || !/^\d+$/.test(val) || val.length > 15) {
      onChange(val, true);
      return true;
    }
    return false;
  };

  const handleChange = (val, countryData) => {
    if (validate(val, countryData)) return;
    if (onChange) onChange(val, false);
  };

  return (
    
      <div className="phone-input-filled">
        <PhoneInput
          country={ configData?.config?.countryISOCode || "in" }
          value={value}
          onChange={handleChange}
          enableSearch
          specialLabel=""
          inputProps={{ id: "phone", name: "phone", required: true }}
        />
      </div>
 
  );
};

export default PhoneNumberInput;
